import React from "react";

import Button from "../Button";

import DeleteIcon from "@material-ui/icons/Delete";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import { DialogActions as MaterialDialogActions, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: theme.spacing(3, 0, 1, 0),
  },
  container: {
    display: "flex",
    width: 270,
    justifyContent: "space-between",
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
  },
  marginNone: {
    margin: 0,
    [theme.breakpoints.only("xs")]: {
      margin: theme.spacing(0.5),
    },
  },
  error: {
    color: theme.palette.error.main,
  },
}));

type RodaDialogProps = {
  handleClose: () => void;
  handleSubmit: () => void;
  message?: string | boolean;
};

export default function DialogActions({
  handleClose,
  handleSubmit,
  message,
}: RodaDialogProps) {
  const classes = useStyles();
  return (
    <MaterialDialogActions classes={{ root: classes.dialogActions }}>
      <div className={classes.container}>
        <Button
          onClick={handleClose}
          startIcon={<DeleteIcon />}
          className={classes.marginNone}
          variant="outlined"
        >
          Poništi
        </Button>
        <Button
          onClick={handleSubmit}
          startIcon={<CheckRoundedIcon />}
          className={classes.marginNone}
        >
          Potvrdi
        </Button>
      </div>
      {message && (
        <Typography variant="body1" className={classes.error}>
          {message}
        </Typography>
      )}
    </MaterialDialogActions>
  );
}
